// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		$(".load-image").each(function() {
			var self = $(this), img = self.find(".background-image");
			self.css("background-image", "url(" + img.attr("src") + ")");
			img.hide();
		  });

		//Call function with browser is resized.
		//$(window).resize(function (event) {
			//resizeWindow();
		//});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		/* animation cleanlines section homepage */
		$('.clean-lines-button').click(function() {
		    if($('.clean-lines-section').css("left") == "-420px")
		    {
		        $(".clean-lines-section").animate({left: '0'});
		        $('.clean-lines-button').fadeOut();
		        $('.close-cleanlines').fadeIn();
		    }
		    else
		    {
		       $(".clean-lines-section").animate({left: '-420px'});
		       $('.clean-lines-button').fadeIn();
		       $('.close-cleanlines').fadeOut();
		    }
		});

		$('.close-cleanlines').click(function() {
			$(".clean-lines-section").animate({left: '-420px'});
			$('.clean-lines-button').fadeIn();
		});
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');
		var width = $(window).width();
		var width_all= width;
		var width2 = width /3;
		$(".courses-home .image" ).css('width',width2);
		//$(".header" ).css('width',width_all);
		
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		/* $('a')
		.live('touchstart', function(){
			isScrolling = false;
		})
		.live('touchmove', function(e){
			isScrolling = true;
		})
		.live('touchend', function(e){
			if( !isScrolling )
			{
				window.location = $(this).attr('href');
			}
		}); */
		
		// $(function() {

		// 	var $body = $(document);
		// 	$body.bind('scroll', function() {
		// 		// "Desactivar" el scroll horizontal
		// 		if ($body.scrollLeft() !== 0) {
		// 			$body.scrollLeft(0);
		// 		}
		// 	});
		
		// }); 
	};



$(window).resize(function(){

       if ($(window).width() <= 1500) {  
		var width = $(window).width();
	
		$(window).on('resize', function() {
		  if ($(this).width() != width) {
			width = $(this).width();
			var width2 = width /3;
			var width_all= width;
		
			$(".courses-home .image" ).css('width',width2);
			//$(".header" ).css('width',width_all);
			//$(".courses-home" ).css('width',width_all);
		  }
		});
	   }
	   
	   
		// $(function() {

		// 	var $body = $(document);
		// 	$body.bind('scroll', function() {
		// 		// "Desactivar" el scroll horizontal
		// 		if ($body.scrollLeft() !== 0) {
		// 			$body.scrollLeft(0);
		// 		}
		// 	});
		
		// }); 

});
	


}());



function scrollW(){

	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 120){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('backto').style.display = 'none';
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			document.getElementById('backto').style.display = 'block';
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}


//courses home
$( ".short" ).hide();
$( ".large" ).hide();
$(".post-home .text").hide();
$(".post-home a.btn").hide();
	$(".courses-home .wrapper .post-home").hover(function(){
			$(this).addClass("hover-courses");
			$(this).removeClass("inactive-hover");
			$(".post-home" ).css('width','27,5%');
			$(this).find(".text").show();
			$(this).find("a.btn").show();
			$(".post-home" ).css('width','27,5%');
			$(this, ".post-home.hover-courses").css('width','45%');
		}, function(){
			$(".image" ).css('width','100%');
			$(this).removeClass("hover-courses");
			$(".post-home" ).css('width','33%');
			$(".post-home").addClass("inactive-hover");
			$(".post-home.inactive-hover" ).css('width','33%');
			$(".post-home .text").hide();
			$(".post-home a.btn").hide();	
	});

 /* Placeholder for tuition form inputs */

document.addEventListener('DOMContentLoaded', () => {
	const tuitionForm = document.getElementById('tuition-form')
	/* Validate if form exists */
	if (!tuitionForm) {
		console.error('Tuition form not found');
		return;
	}

	const tuitionFormInputs = tuitionForm.querySelectorAll('.form-module__field input, .form-module__field textarea');

	/* Placeholder Texts */
	const placeholders = {
		name: "Your Name",
		email_address: "Youremail@gmail.com",
		phone: "Xxx-xxx-xxx",
		desired_dates: "MM/DD/YYY",
		comments: "Your Comment"
	};

	tuitionFormInputs.forEach(input => {
		const placeholder = placeholders[input.name];		
		if(placeholder) {
			input.setAttribute("placeholder", placeholder);
		}
	});
});






	


